(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .config(EdufindmeRoute);

    EdufindmeRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function EdufindmeRoute ($stateProvider) {
        $stateProvider
            .state('root.physicalfairs', {
                abstract: true,
                url: '/physicalfairs',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                },
            })
            .state ('root.physicalfairs.students', {
                url: '/report/students',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/students/reportFilter.html',
                        controller: 'PhysicalFairStudentsController',
                        controllerAs: 'physicalFairs',
                    }
                }
            })
            .state('root.physicalfairs.students.enrolled', {
                url: '/students/enrolled',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/students/students-enrolled/reportFilter.html',
                        controller: 'PhysicalFairStudentsEnrolledController',
                        controllerAs: 'physicalFairStudentsEnrolled'
                    }
                }
            })
            .state ('root.physicalfairs.students.overTime', {
                url: '/overTime',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/students/overTime/reportFilter.html',
                        controller: 'PhysicalFairStudentsAnalyticController',
                        controllerAs: 'physicalFairsAnalytic',
                    }
                }
            })
            .state ('root.physicalfairs.students.studentReal', {
                url: '/total-student',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/students/total-student-real/reportFilter.html',
                        controller: 'ExpoStudentsRealController',
                        controllerAs: 'ExpoStudentsReal',
                    }
                }
            })
            .state ('root.physicalfairs.students.registrationsData', {
                url: '/registrationsData',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/students/registrations-data/reportFilter.html',
                        controller: 'PhysicalFairStudentsRegistrationsDataController',
                        controllerAs: 'physicalFairStudentsRegistrationsDataController'
                    }
                }
            })
            .state ('root.physicalfairs.students.phones', {
                url: '/phones',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/students/phones/reportFilter.html',
                        controller: 'PhysicalFairStudentsPhonesController',
                        controllerAs: 'physicalFairStudentsPhonesController'
                    }
                }
            })
            .state ('root.physicalfairs.students.emails', {
                url: '/emails',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/students/emails/reportFilter.html',
                        controller: 'PhysicalFairStudentsEmailsController',
                        controllerAs: 'physicalFairStudentsEmailsController'
                    }
                }
            })
            .state ('root.physicalfairs.networkingCounselors', {
                url: '/report/networking-counselors',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/networking/reportFilter.html',
                        controller: 'PhysicalFairNetworkingController',
                        controllerAs: 'networkingCtrl'
                    }
                }
            })
            .state ('root.physicalfairs.expositors', {
                url: '/report/expositors',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/expositors/reportFilter.html',
                        controller: 'PhysicalFairExpositorsController',
                        controllerAs: 'physicalFairsExpositors',
                    }
                }
            })
            .state ('root.physicalfairs.exhibitors', {
                url: '/exhibitors',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/exhibitors/physicalFairExhibitors.html',
                        controller: 'PhysicalFairExhibitorsController',
                        controllerAs: 'physicalFairExhibitors',
                    }
                }
            })
            .state ('root.physicalfairs.exhibitors.roadshowSurvey', {
                url: '/roadshow-survey',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/exhibitors/roadshow-survey/reportFilter.html',
                        controller: 'PhysicalFairRoadshowSurveyController',
                        controllerAs: 'roadshowSurvey'
                    }
                }
            })
            .state ('root.physicalfairs.exhibitors.createSurvey', {
                url: '/create-survey',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/exhibitors/create-survey/reportFilter.html',
                        controller: 'PhysicalFairCreateSurveyController',
                        controllerAs: 'createSurvey'
                    }
                }
            })
            .state ('root.physicalfairs.exhibitors.premiumBooths', {
                url: '/premium-booths',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/exhibitors/premium-booths/reportFilter.html',
                        controller: 'PhysicalFairExhibitorsPremiumBoothsController',
                        controllerAs: 'premiumBooths'
                    }
                }
            })
            
            .state ('root.physicalfairs.preApproved', {
                url: '/pre-approved',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/pre-approved/physicalFairPreApproved.html',
                        controller: 'PhysicalFairPreApprovedController',
                        controllerAs: 'physicalFairPreApproved',
                    }
                }
            })
            .state ('root.physicalfairs.exhibitorsByExpo', {
                url: '/report/exhibitors/expo',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/exhibitors-by-expo/reportFilter.html',
                        controller: 'PhysicalFairExhibitorByExpoReportController',
                        controllerAs: 'physicalFairExhibitorsByExpo',
                    }
                }
            })
            .state ('root.physicalfairs.uncompletedRegistrations', {
                url: '/report/uncompleted/registrations',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/uncompleted-registrations/reportFilter.html',
                        controller: 'PhysicalFairUncompletedRegistrationsController',
                        controllerAs: 'physicalFairUncompletedRegistrations'
                    }
                }
            })
            // .state ('root.physicalfairs.seminars', {
            //     url: '/report/seminars',
            //     views: {
            //         'inner-view@root': {
            //             templateUrl: 'templates/physicalfairs/reports/seminars/reportFilter.html',
            //             controller: 'PhysicalFairSeminarsController',
            //             controllerAs: 'physicalFairSeminars'
            //         }
            //     }
            // })
            .state ('root.physicalfairs.goals', {
                url: '/goals',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/goals/reportFilter.html',
                        controller: 'PhysicalFairGoalsController',
                        controllerAs: 'physicalFairGoals'
                    }
                }
            })
            .state ('root.physicalfairs.goalsReports', {
                url: '/report/goals',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/goals-report/reportFilter.html',
                        controller: 'PhysicalFairGoalsReportController',
                        controllerAs: 'physicalFairGoalsReport'
                    }
                }
            })

            .state ('root.physicalfairs.commentsReports', {
                url: '/report/comments',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/comments/reportFilter.html',
                        controller: 'PhysicalFairCommentsController',
                        controllerAs: 'physicalFairCommentsController'
                    }
                }
            })

            .state ('root.physicalfairs.exhibitorsDescriptions', {
                url: '/report/exhibitors/descriptions',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/exhibitors-descriptions/reportFilter.html',
                        controller: 'PhysicalFairExhibitorsDescriptionsController',
                        controllerAs: 'physicalFairExhibitorsDescriptionsController'
                    }
                }
            })
            .state ('root.physicalfairs.totalStudents', {
                url: '/report/total-students',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/total-student/list.html',
                        controller: 'PhysicalFairTotalStudentsController',
                        controllerAs: 'physicalFairTotalStudents'
                    }
                }
            })
            .state ('root.physicalfairs.badges', {
                url: '/report/badges',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/badges/reportFilter.html',
                        controller: 'PhysicalFairBadgesController',
                        controllerAs: 'physicalFairBadgesController',
                        resolve: {
                            expos: function (toastr, $state, ExpoService) {
                                return ExpoService.getExpos()
                                    .then(response => response.data)
                                    .catch(err => {
                                        toastr.error('Something went wrong. Please try again later');
                                        console.log(err);
                                        return $state.go('root.physicalfairs.preRegistrations', null, {reload:true});
                                    });
                            }
                        }
                    }
                }
            })
            .state ('root.physicalfairs.fasciaName', {
                url: '/report/fascianame',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/fascianame/reportFilter.html',
                        controller: 'PhysicalFairFasciaNameController',
                        controllerAs: 'physicalFairFasciaNameController'
                    }
                }
            })
            .state ('root.physicalfairs.publicRelationsTexts', {
                url: '/report/publicrelationstexts',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/publicrelationstexts/reportFilter.html',
                        controller: 'PhysicalFairPublicRelationsTextsController',
                        controllerAs: 'physicalFairPublicRelationsTextsController'
                    }
                }
            })
            .state ('root.physicalfairs.reports', {
                url: '/report/physicalfair/reports',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/reports.html',
                        controller: 'physicalFairsReportController',
                        controllerAs: 'physicalFairsReport'
                    }
                },
            })
            .state ('root.physicalfairs.letters', {
                url: '/report/letters',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/letters/reportFilter.html',
                        controller: 'PhysicalFairLettersController',
                        controllerAs: 'physicalFairLettersController'
                    }
                }
            })
            .state ('root.physicalfairs.acceptedInvoices', {
                url: '/report/accpetedinvoices',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/accepted-invoices/reportFilter.html',
                        controller: 'PhysicalFairAcceptedInvoicesController',
                        controllerAs: 'physicalFairAcceptedInvoicesController'
                    }
                }
            })
            .state ('root.physicalfairs.flightsRequests', {
                url: '/report/flightsrequests',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/flights-requests/reportFilter.html',
                        controller: 'PhysicalFairFlightsRequestsController',
                        controllerAs: 'physicalFairFlightsRequestsController'
                    }
                }
            })
            .state ('root.physicalfairs.emailExhibitorsSelection', {
                url: '/report/emailExhibitorsSelection',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/email-exhibitors-selection/reportFilter.html',
                        controller: 'PhysicalFairEmailExhibitorsSelectionController',
                        controllerAs: 'physicalFairEmailExhibitorsSelectionController'
                    }
                }
            })
            .state ('root.physicalfairs.boothTableBooked', {
                url: '/report/boothtablebooked',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/boothtablebooked/reportFilter.html',
                        controller: 'PhysicalFairBoothTableBookedController',
                        controllerAs: 'physicalFairBoothTableBookedController'
                    }
                }
            })

            .state ('root.physicalfairs.preRegistrations', {
                url: '/report/pre-registrations',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/pre-registrations/reportFilter.html',
                        controller: 'PhysicalFairPreRegistrationsController',
                        controllerAs: 'physicalFairPreRegistrations'
                    }
                }
            })
            .state ('root.physicalfairs.settings', {
                url: '/settings',
                resolve: {
                    expos: async function(ExpoService) {
                        return await ExpoService.getExpos().then(function(response) {
                            return response.data;
                        });
                    },
                    sellers: async function(SellerService) {
                        return await SellerService.getStaff().then(function(response) {
                            return response.data;
                        });
                    },
                },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/settings/reportFilter.html',
                        controller: 'PhysicalFairSettingsController',
                        controllerAs: 'physicalFairSettings'
                    }
                },
            })
            .state ('root.physicalfairs.eventVenue', {
                url: '/event-venue',
                resolve: {
                    addresses: async function (ExpoService) {
                        return await ExpoService.getEventVenues().then(function(response) {
                            return response.data;
                        });
                    },
                },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/event-venue/reportFilter.html',
                        controller: 'PhysicalFairEventVenueController',
                        controllerAs: 'physicalFairEventVenue'
                    }
                },
            })
            .state ('root.physicalfairs.eventVenue.form', {
                url: '/form/:id?',
                resolve: {
                    cities: async function (ExpoService) {
                        return await ExpoService.getAllExpoCities().then(function(response) {
                            return response.data;
                        });
                    },
                    eventVenue: async function(ExpoService, $stateParams) {
                        if($stateParams.id) {
                            return await ExpoService.getEventVenues({ 'id' : $stateParams.id }).then(function(response) {
                                if (response.data.length) {
                                    return response.data[0];
                                }
                                return
                            });
                        }
                        return null;
                    },
                },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/event-venue/form/form.html',
                        controller: 'PhysicalFairEventVenueFormController',
                        controllerAs: 'physicalFairEventVenueForm'
                    }
                },
            })
            .state("root.physicalfairs.settings.form", {
                url: "/form/:id?",
                resolve: {
                    expo: async function(ExpoService, $stateParams) {
                        console.log($stateParams.id);
                        if($stateParams.id) {
                            return await ExpoService.getPhysicalFairBySettings($stateParams.id).then(function(response) {
                                return response.data;
                            });
                        }
                        return null;
                    },
                    expoTypes: async function (ExpoService) {
                        return await ExpoService.getExpoTypes().then(function(response){
                            return response.data;
                        });
                    },
                    aliases: async function (ExpoService) {
                        return await ExpoService.getAliases().then(function(response) {
                            return response.data;
                        });
                    },
                    serviceRegions: async function (ExpoService) {
                        return await ExpoService.getServiceRegions().then(function(response) {
                            return response.data;
                        });
                    },
                    costCenters: async function (InvoicesService) {
                        return await InvoicesService.getInvoicesCostCenterCategory().then(function(response) {
                            return response.data;
                        });
                    },
                    currencies: async function (InvoicesService) {
                        return await InvoicesService.getCurrencies().then(function(response) {
                            return response.data;
                        });
                    },
                    eventGroups: async function (ExpoService) {
                        return await ExpoService.getEventGroups().then(function(response) {
                            return response.data;
                        });
                    },
                    profileTypes: async function (ExpoService) {
                        return await ExpoService.getProfileTypes().then(function(response) {
                            return response.data;
                        });
                    },
                    cities: async function (ExpoService) {
                        return await ExpoService.getAllExpoCities().then(function(response) {
                            return response.data;
                        });
                    },
                },
                views: {
                  "inner-view@root": {
                    templateUrl: "templates/physicalfairs/settings/form/form.html",
                    controller: "PhysicalFairSettingsFormController",
                    controllerAs: "physicalFairSettingsForm",
                  },
                },
                params: {id: null},
              })
              .state("root.physicalfairs.eventContacts", {
                url: "/report/event-contacts",
                resolve: {
                  expos: function(ExpoService) {
                    return ExpoService.getExpos()
                      .then(response => response.data)
                  },
                  semesters: function(VirtualFairService) {
                    return VirtualFairService.getSemesters()
                      .then(response => response.data)
                  }
                },
                views: {
                  "inner-view@root": {
                    templateUrl: "templates/physicalfairs/reports/event-contacts/reportFilter.html",
                    controller: "PhysicalFairEventContactsController",
                    controllerAs: "physicalFairEventContacts",
                  }
                }
            })
            .state ('root.physicalfairs.preRegistrations.register', {
                url: '/:userId/register/:prId?showBt={showValidateBt}',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/pre-registrations/registration/registration-form.html',
                        controller: 'PhysicalFairRegistrationController',
                        controllerAs: 'pfRegCtrl'
                    }
                },
                resolve: {
                    expos: function ($state, $stateParams, toastr, ExpoService) {
                        return ExpoService.getExpos({
                            active: true,
                            show_to_costumer: true,
                            include_past_date: false,
                            user_id: $stateParams.userId,
                            pr_id: $stateParams.prId
                        })
                            .then(response => response.data)
                            .catch(err => {
                                toastr.error('Something went wrong. Please try again later');
                                console.log(err);
                                return $state.go('root.physicalfairs.preRegistrations', null, {reload:true});
                            });
                    }
                }
            })

            .state ('root.physicalfairs.expenses', {
                url: '/expenses',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/expenses/list.html',
                        controller: 'PhysicalFairExpensesController',
                        controllerAs: 'physicalFairExpensesController'
                    }
                }
            })

            .state ('root.physicalfairs.expenses.new', {
                url: '/expenses/new',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/expenses/form/form.html',
                        controller: 'PhysicalFairExpensesFormController',
                        controllerAs: 'physicalFairExpensesFormController'
                    }
                }
            })

            .state ('root.physicalfairs.expenses.edit', {
                url: '/expenses/{id}/edit',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/expenses/form/form.html',
                        controller: 'PhysicalFairExpensesFormController',
                        controllerAs: 'physicalFairExpensesFormController'
                    }
                }
            })
            .state ('root.physicalfairs.sponsors', {
                url: '/report/sponsors',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/sponsor/reportFilter.html',
                        controller: 'PhysicalFairSponsorController',
                        controllerAs: 'physicalFairSponsor'
                    }
                }
            })

            .state ('root.physicalfairs.boothTypes', {
                url: '/report/boothTypes',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/booth-types/reportFilter.html',
                        controller: 'PhysicalFairBoothTypesController',
                        controllerAs: 'physicalFairBoothType'
                    }
                }
            })
            .state ('root.physicalfairs.sideEvents', {
                url: '/report/sideEvents',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/side-events/reportFilter.html',
                        controller: 'PhysicalFairSideEventsController',
                        controllerAs: 'physicalSideEvents'
                    }
                }
            })
            .state ('root.physicalfairs.translators', {
                url: '/report/translators',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/physicalfairs/reports/translators/reportFilter.html',
                        controller: 'PhysicalFairTranslatorController',
                        controllerAs: 'physicalFairTranslator'
                    }
                }
            })
            .state("root.physicalfairs.approved", {
                url: "/approved",
                views: {
                  "inner-view@root": {
                    templateUrl:
                      "templates/physicalfairs/approved/physicalFairApproved.html",
                    controller: "PhysicalFairApprovedController",
                    controllerAs: "physicalFairApproved",
                  },
                },
                params: {
                  msgToast: null,
                },
              })
            .state('root.physicalfairs.generalInformation', {
                url: "/report/post-event/general-information",
                views: {
                  "inner-view@root": {
                    templateUrl:
                      "templates/physicalfairs/reports/post-event/general-information/reportFilter.html",
                    controller: "PhysicalFairGeneralInformationController",
                    controllerAs: "physicalFairGeneralInformation",
                  },
                },
                resolve: {
                    expos: function ($state, $stateParams, toastr, ExpoService) {
                        return ExpoService.postEvents()
                            .then(response => response.data)
                            .catch(err => {
                                toastr.error('Something went wrong. Please try again later');
                                console.log(err);
                            });
                    },
                  isPrivate: () => false,
                }
            })
            .state('root.physicalfairs.prizes', {
                url: "/report/post-event/prizes",
                views: {
                    "inner-view@root": {
                        templateUrl:
                            "templates/physicalfairs/reports/post-event/prizes/reportFilter.html",
                        controller: "PhysicalFairPrizesController",
                        controllerAs: "pfPrizes",
                    },
                },
                resolve: {
                    expos: function ($state, $stateParams, toastr, ExpoService) {
                        return ExpoService.postEvents()
                            .then(response => response.data)
                            .catch(err => {
                                toastr.error('Something went wrong. Please try again later');
                                console.log(err);
                            });
                    },
                }
            })
            .state("root.physicalfairs.leadsBooth", {
                url: "/leads-per-booth",
                views: {
                  "inner-view@root": {
                    templateUrl:
                      "templates/physicalfairs/reports/post-event/leads-booth/reportFilter.html",
                    controller: "PhysicalFairLeadsBoothController",
                    controllerAs: "physicalFairrLeadsBooth",
                  },
                },
                resolve: {
                  expos: function () {
                    return null;
                  },
                  isPrivate: () => false,
                }
            })
            .state("root.physicalfairs.seminars", {
                url: "/seminars",
                views: {
                  "inner-view@root": {
                    templateUrl:
                      "templates/physicalfairs/seminars/physicalFairSeminars.html",
                    controller: "PhysicalFairSeminarsController",
                    controllerAs: "physicalFairSeminars",
                  },
                },
                params: {
                  msg: null,
                  error: false,
                },
              })

              .state("root.physicalfairs.seminars.form", {
                url: "/form/:id?",
                resolve: {
                  seminars: function(ExpoService, $stateParams) {
                    if($stateParams.id) {
                      return ExpoService.getSeminarById($stateParams.id).then(function(response) {
                        return response.data;
                      });
                    }
                    return null;
                  },
                  expo: function(ExpoService){
                    return ExpoService.getExpos().then(function(response){
                        return response.data;
                    })
                  }
                },
                views: {
                  "inner-view@root": {
                    templateUrl: "templates/physicalfairs/seminars/form/form.html",
                    controller: "PhysicalFairSeminarsFormController",
                    controllerAs: "physicalFairSeminarsForm",
                  },
                },
                params: {id: null},
              })


            
            // .state ('root.physicalFairs.expo', {
            //     url: '/expo/{id}',
            //     views: {
            //         'inner-expo@root': {
            //             templateUrl: 'templates/edufindme/findClients/list/expo.html',
            //             controller: 'FindClientsExpoController',
            //             controllerAs: 'expo'
            //         }
            //     }
            // })

    }
})();